import React, { FC, ReactElement } from 'react';
import { EventCardComponentsProps } from './types';

const EventCardImage: FC<EventCardComponentsProps> = ({ children, className }): ReactElement => {
  return (
    <div className={className}>{children}</div>
  );
};

export { EventCardImage };